import React from "react";
import "./SocialButtons.css";
import { useWebsiteSettings } from '../contexts/WebsiteSettingsContext';

const SocialButtons = () => {
    const { settings, isLoading } = useWebsiteSettings();
    if (isLoading) return null; // show nothing while loading

    return (
        <div className="sbuttons">
            {/* MAIN BUTTON + Hidden Socials */}
            <div className="main-wrapper">
                <button className="sbutton main" tooltip="Share">
                    <i className="bi bi-share-fill"></i>
                </button>

                <div className="socials">
                    {settings?.facebook && (
                        <a
                            href={settings.facebook}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="sbutton fb"
                            tooltip="Facebook"
                        >
                            <i className="bi bi-facebook"></i>
                        </a>
                    )}
                    {settings?.instagram && (
                        <a
                            href={settings.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="sbutton instagram"
                            tooltip="Instagram"
                        >
                            <i className="bi bi-instagram"></i>
                        </a>
                    )}
                    {settings?.linkedin && (
                        <a
                            href={settings.linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="sbutton linkedin"
                            tooltip="LinkedIn"
                        >
                            <i className="bi bi-linkedin"></i>
                        </a>
                    )}

                </div>
            </div>
        </div>
    );
};

export default SocialButtons;
